<template>
    <main class="main container mx-auto">
      <div class="banner">
        <section role="banner">
          <p class="text-3xl font-medium">{{$t('homepage.hey').toUpperCase()}} :)</p>
          <p>
            <vue-typer :text="$t(`homepage.im`)" :repeat="0" :type-delay="300" class="text-3xl font-bold" />
            <vue-typer :text="$t('name')"
                       caret-animation="phase"
                       :pre-type-delay='typingDelay'
                       :type-delay="300"
                       :repeat="0"
                       class="pl-3 text-3xl sm:text-4xl font-family-8bit"/>
          </p>
          <p>
            <vue-typer class="text-lg font-medium" :repeat="0"
                       :text="[$t('homepage.waiting_for_response')+'...', $t('homepage.post')]"
                       :type-delay="200"/>
          </p>
        </section>
      </div>
      <section class="space-y-5 md:space-y-0 flex flex-col md:flex-row justify-between">
        <who-am-i-section id="who-am-i" class="w-full lg:w-1/2" />
        <skills-section id="skills" class="mt-5 md:mt-0 w-full" />
      </section>
      <formation-section id="formations" />
      <projects-section id="projects" />
      <contact-section id="contact" />
      <base-navigator class="hidden sm:block" :navigables="navigables" />
    </main>
</template>

<script>
import { VueTyper } from 'vue-typer'
import ProjectsSection from '../components/section/home/ProjectsSection'
import SkillsSection from '../components/section/home/SkillsSection'
import WhoAmISection from '../components/section/home/WhoAmISection'
import BaseNavigator from '../components/base/navigator/BaseNavigator'
import ContactSection from '../components/section/home/ContactSection'
import FormationSection from '../components/section/home/FormationSection'

export default {
  name: 'Home',
  components: { FormationSection, ContactSection, BaseNavigator, WhoAmISection, SkillsSection, ProjectsSection, VueTyper },
  metaInfo () {
    return {
      title: this.$t('homepage.page_title'),
      titleTemplate: null,
      htmlAttrs: {
        lang: this.$i18n.locale, amp: true
      },
      meta: [
        {
          name: 'description',
          content: this.$t('homepage.whoami.content')
        }
      ]
    }
  },
  computed: {
    navigables () {
      return [{
        id: 'who-am-i', text: this.$t('homepage.whoami.title')
      }, {
        id: 'skills', text: this.$t('homepage.skills')
      }, {
        id: 'formations', text: 'Formation'
      }, {
        id: 'projects', text: this.$t('projects.title')
      }, {
        id: 'contact', text: this.$t('homepage.contact.title')
      }
      ]
    },
    typingDelay () {
      if (this.$i18n.locale === 'fr') {
        return 3000
      }
      return 1300
    }
  }
}
</script>

<style scoped>
.banner {
  @apply flex items-center;
  height: 400px;
}
.main > section:nth-child(n+3){
  margin-top: 2rem;
  margin-bottom: 2rem;
}
</style>
